export default "__VITE_ASSET__BTTdrvoI__"